import React, { Component, PropTypes } from 'react';

class PagesReview extends Component {
    render() {
        return (
            <div>
                Content of PagesReview
                <hr />
                {this.props.children}
            </div>
        );
    }
}

PagesReview.propTypes = {
    children: PropTypes.element
};

export default PagesReview;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesReview.js